import React        from 'react'
import { Link }     from 'react-router-dom'
import Blob1        from './blob1.svg'
import Blob         from './blob.svg'
import Sectionx     from './section.png'
import Work         from './work.png'

const Section = () => {
    return (
        <div className="section-container">
            <div className="section-header">
                <h1>Make your website</h1>
                <h1 className="linear">wonderful</h1>
                <p>"Neque porro quisquam est qui dolorem ipsum quia dolor sit amet, consectetur, adipisci velit..."kimse yoktur. Nedeni basit. Çünkü o acıdır..."</p>
                <Link to="/contact">
                    <button>Iletisime Gec</button>
                </Link>
            </div>
            <div className="section-pictures">
                <img className="blob-1" src={Blob1}/>
                <img className="section-img" src={Sectionx}/>
                <img className="blob-2" src={Blob}/>
            </div>
            <div className="section-content">
                <h1>Suana kadar calistigimiz referanslarimiz</h1>
                <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Cras tristique pretium metus. Vivamus ultrices erat nunc, id suscipit magna venenatis id. Ut eget orci ut ipsum sollicitudin lobortis sed vitae mi. Etiam</p>
                <img src={Work} />
            </div>
        </div>
    )
}

export default Section;